import React from 'react';
import { toast } from 'react-toastify';
import ProfileImage from '../WebChat/Common/ProfileImage';
import ToastServices from './ToastServices';

let userJoinedList = [],
    userLeftList = [];

export const getToastElement = (msg, imageToken, imageTokenThumb, initial) => (
    <div className="customToastWrapper">
        <div className="customToast show">
            <div className="outertoast">
                <ProfileImage
                    chatType={'chat'}
                    imageToken={imageTokenThumb !== '' ? imageTokenThumb : imageToken}
                    name={initial}
                />
            </div>
            <span>{msg}</span>
        </div>
    </div>
);

export const updateUserList = (type, displayName, toastType) => {
    const addUnique = (list, name) => {
        if (!list.includes(name)) list.push(name);
    };

    const removeFromList = (list, name) => {
        const index = list.indexOf(name);
        if (index !== -1) list.splice(index, 1);
    };

    if (type === 'join') {
        if (toastType === 'open') {
            addUnique(userJoinedList, displayName);
            removeFromList(userLeftList, displayName);
        } else {
            removeFromList(userJoinedList, displayName);
        }
    }
    if (type === 'left') {
        if (toastType === 'open') {
            removeFromList(userJoinedList, displayName);
            addUnique(userLeftList, displayName);
        } else {
            removeFromList(userLeftList, displayName);
        }
    }
};

export const getMessage = (userList = []) => {
    if (userList.length === 0) return '';
    else if (userList.length === 1) return userList[0];
    else return `${userList[0]} and ${userList.length - 1} more have `;
};

export const callLinkToast = (type, displayName, imageToken = '', imageTokenThumb = '', initial = '', toastId = '') => {
    updateUserList(type, displayName, 'open');
    let msg = type === 'join' ? `${getMessage(userJoinedList)} joined` : `${getMessage(userLeftList)} left`;
    if (toast.isActive(toastId)) {
        toast.update(toastId, { render: getToastElement(msg, imageToken, imageTokenThumb, initial) });
    }

    ToastServices.ParticipantToast(
        getToastElement(msg, imageToken, imageTokenThumb, initial),
        toastId,
        displayName,
        type,
    );
};
